package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationZangfuPathogenesis(private val literal: String) : IEnumType {
	心气虚("心气虚"),
	心阳虚("心阳虚"),
	心阳虚脱("心阳虚脱"),
	心血虚("心血虚"),
	心阴虚("心阴虚"),
	心脉痹阻之瘀阻心脉("心脉痹阻之瘀阻心脉"),
	心脉痹阻之痰阻心脉("心脉痹阻之痰阻心脉"),
	心脉痹阻之寒凝心脉("心脉痹阻之寒凝心脉"),
	心脉痹阻之气滞心脉("心脉痹阻之气滞心脉"),
	痰蒙心神_痰蒙心窍("痰蒙心神_痰蒙心窍"),
	痰火扰神_痰火扰心("痰火扰神_痰火扰心"),
	心火亢盛("心火亢盛"),
	瘀阻脑络("瘀阻脑络"),
	小肠实热("小肠实热"),
	肺气虚("肺气虚"),
	肺阴虚("肺阴虚"),
	风寒犯肺("风寒犯肺"),
	寒痰阻肺_寒饮停肺_痰浊阻肺("寒痰阻肺_寒饮停肺_痰浊阻肺"),
	饮停胸胁("饮停胸胁"),
	风热犯肺("风热犯肺"),
	肺热炽盛_肺热_肺火("肺热炽盛_肺热_肺火"),
	痰热壅肺("痰热壅肺"),
	燥邪犯肺("燥邪犯肺"),
	风水相搏("风水相搏"),
	肠道湿热_大肠湿热("肠道湿热_大肠湿热"),
	肠热腑实_大肠热结_大肠实热("肠热腑实_大肠热结_大肠实热"),
	肠燥津亏("肠燥津亏"),
	脾气虚("脾气虚"),
	脾阳虚("脾阳虚"),
	脾虚气陷_中气下陷("脾虚气陷_中气下陷"),
	脾不统血_脾不摄血("脾不统血_脾不摄血"),
	湿热蕴脾_中焦湿热_脾经湿热("湿热蕴脾_中焦湿热_脾经湿热"),
	寒湿困脾_湿困脾阳_寒湿中阻_太阴寒湿("寒湿困脾_湿困脾阳_寒湿中阻_太阴寒湿"),
	胃气虚("胃气虚"),
	胃阳虚_胃虚寒("胃阳虚_胃虚寒"),
	胃阴虚_胃虚热("胃阴虚_胃虚热"),
	胃热炽盛_胃实热("胃热炽盛_胃实热"),
	寒饮停胃("寒饮停胃"),
	寒滞胃肠_中焦实寒_寒滞胃脘("寒滞胃肠_中焦实寒_寒滞胃脘"),
	食滞胃肠_食滞胃脘("食滞胃肠_食滞胃脘"),
	胃肠气滞("胃肠气滞"),
	肝血虚("肝血虚"),
	肝阴虚_肝虚热("肝阴虚_肝虚热"),
	肝郁气滞_肝气郁结("肝郁气滞_肝气郁结"),
	肝火炽盛_肝火上炎_肝经实火("肝火炽盛_肝火上炎_肝经实火"),
	肝阳上亢("肝阳上亢"),
	肝风内动之肝阳化风("肝风内动之肝阳化风"),
	肝风内动之热极生风("肝风内动之热极生风"),
	肝风内动之阴虚动风("肝风内动之阴虚动风"),
	肝风内动之血虚生风("肝风内动之血虚生风"),
	寒滞肝脉_寒凝肝经_肝寒_肝经实寒("寒滞肝脉_寒凝肝经_肝寒_肝经实寒"),
	肝胆湿热("肝胆湿热"),
	胆郁痰扰("胆郁痰扰"),
	肾阳虚_元阳亏虚_命门火衰("肾阳虚_元阳亏虚_命门火衰"),
	肾阴虚_真阴亏虚_肾水亏虚("肾阴虚_真阴亏虚_肾水亏虚"),
	肾精不足("肾精不足"),
	肾气不固("肾气不固"),
	肾虚水泛("肾虚水泛"),
	膀胱湿热("膀胱湿热"),
	三焦湿热("三焦湿热");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_zangfu_pathogenesis"}
	override fun getLiteral(): String {return literal}
}
